import { toast as islandToast } from "@/lib/notification-store";
import type { ToastOptions } from "@/lib/notification-store";

export type { ToastOptions };

// Keep Sonner-like call shape while routing all notifications to Dynamic Island.
export const toast = Object.assign(
  (message: string, options?: ToastOptions) => islandToast.message(message, options),
  {
    success: islandToast.success,
    error: islandToast.error,
    warning: islandToast.warning,
    info: islandToast.info,
    library: islandToast.library,
    sparkles: islandToast.sparkles,
    message: islandToast.message,
  },
);
